import styled from 'styled-components';

export const VideoContainer = styled.div`
    background-color: #3a3a3a;
    height: 320px;

    @media (max-width: 1024px) {
        height: 40vw;
    }

    @media (max-width: 425px) {
        height: 95vw;
    }
`;

export const Video = styled.div`
    display: flex;
    justify-content: center;
    height: 320px;

    @media (max-width: 1024px) {
        height: 40vw;
    }

    @media (max-width: 425px) {
        height: 95vw;
    }
`;
